import PropTypes from "prop-types"

import { useInvoiceActionContext } from "./useInvoiceActionContext"

const WithInvoiceActionContext = ({ invoiceId, onError, children }) => {
  const context = useInvoiceActionContext(invoiceId, { onError })
  return context ? children(context) : null
}

WithInvoiceActionContext.propTypes = {
  invoiceId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
}

export default WithInvoiceActionContext
